module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Chapter Two")])])])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("Dulcie Hughes brought the rented car to a stop in front of a boarded-up old farmhouse in the middle of nowhere.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("This was it? The mysterious Montana property? She couldn’t help her disappointment. She hadn’t known what to expect when she’d flown into Great Falls and driven across what was called the Hi-Line to Whitehorse.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The small Western town hadn’t been much of a surprise, either, after driving through one small Western town after another.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She had driven under the train tracks into Whitehorse, telling herself she understood why her parents had never brought her here. There wasn’t much to see unless you liked cowboys and pickup trucks. That seemed to be the only thing along the main street.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A few bars, churches, cafés and a couple of clothing stores later, she had to backtrack to find a real-estate office for directions to her property.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A cute blonde named April had drawn her a map and told her she couldn’t miss it. Of course that wasn’t true given that the land and all the old farmhouses looked alike. Fortunately she had the GPS coordinates.")])])]), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The difference also was that her farmhouse had apparently been boarded up for years. Weeds had grown tall behind the barbed-wire fence. Nothing about the house looked in the least bit inviting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“How do you feel about bats?” April had asked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("“Bats?”")])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Whitehorse is the northernmost range for migrating little brown bats. They hibernate down in the Little Rockies and Memorial Day they show up in Whitehorse and don’t leave till after Labor Day. They come for the mosquitoes. I hope someone warned you about the mosquitoes. And the wind.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t worry, I won’t be staying long. I’ve just come to see the property for myself before I put it on the market.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So you don’t think you’ll be falling in love with it up here and never want to leave?” April joked.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Dulcie wondered all the way across the top of the state why anyone in their right mind lived here.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I thought there would be mountains and pine trees,” she had said to April.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The Little Rockies are forty miles to the south. There’s pine trees down there. Ponderosas. Your property isn’t far from there.” She’d grinned. “I guess you missed the single pine tree on the edge of town and the sign somebody put up that reads, Whitehorse County National Forest.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Funny. But stuff like that was probably all they had to do around here for fun, Dulcie had thought as she had taken the map and thanked April for her help, promising to get back to her about listing the property.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("For Dulcie, who lived in Chicago, the pine trees and the mountains had been farther than she thought—about twenty miles away.")])])]), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She grabbed her cell phone, unable to wait a moment longer to call Renada and give her the news. But as she flipped it open, she heard the roar of an engine and looked into her rearview mirror to find a huge farm machine of some kind barreling down on her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Fumbling for the key in the ignition, she let out a cry and braced herself for the inevitable crash as her rental car was suddenly shrouded in a cloud of dust.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She must have closed her eyes, waiting for the impact, because when she opened them, she found a pair of very blue, very angry eyes scowling in at her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Turning the key, she whirred down her window since the cowboy hunkered next to her rental car seemed to be mouthing something.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes?” she inquired, cell phone still in hand in case she needed to call for help. “Is there a problem?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He quirked a brow. “Other than you parked in the middle of the road just over a rise? Nope, that about covers it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sorry. Let me pull off the road so you can get around.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Going to take more than that to get a combine through here on this narrow stretch of road, I’m afraid.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("A combine. How interesting.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You lost?” he asked, shoving back his battered gray Stetson to glance over the top of her rental toward the farmhouse, then back to her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He had the most direct blue-eyed stare she’d ever seen.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.” Not that it was any of his business. “I think I’ve seen all I need to see here so I’ll just go on up the road.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“The road dead-ends a mile in the direction you’re headed,” he said. “But if that’s what you want to do. I’m only going another half mile. I can follow you.”")])])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Oh, wouldn’t that be delightful.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I believe in that case I’ll just pull into this house and let you go by,” she said and started to open her door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Want help with the gate?” he asked with a hint of amusement as he stepped back to let her slide from the car.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m sure I can figure it out.” She straightened to her full height of five-nine, counting the two-inch heels of her dress boots, but he still towered over her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Turning her back to him, she walked to the barbed-wire gate strung across the road into the house. She could feel his gaze appraising her and wished she’d worn something more appropriate.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Renada had joked that she needed to buy herself a pair of cowboy boots. She had worn designer jeans, a blouse and a pair of black dress boots with heels. As one of her heels sank into the soft dirt, she wished she’d taken Renada’s advice.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The gate, she found, had an odd contraption at one end, with a wire from the fence post that looped over the gatepost. Apparently all she had to do to open the gate was slip the wire loop off that post.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The gate, though, hadn’t been opened in a while, judging from how deep the wire had sunk into the old wood. The wire dug into her fingers as she tried to slide it upward.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You have to hug it,” the cowboy said, brushing against her as he leaned over her to wrap one arm around the gatepost and the other around the fence post and squeezed. As the two posts came together, he easily slid the wire loop up and off.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('span', [_vm._v("“Thank you,” she said as she ducked out from under his arms and stood back to watch him drag the gate out of the way. He wasn’t just tall, she realized. His shoul")])]), _c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("der muscles bunched as he opened the gate, stretching the fabric of his Western shirt across his broad shoulders, and she’d gotten a good look at his backside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("The only cowboys she’d seen in Chicago were the urban types. None of them had this man’s rough-and-tough appearance. Nor had their jeans fit them quite like this cowboy’s did, she couldn’t help noticing.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“I’d be watching out for rattlesnakes if I were you,” he called after her as she turned to head for her car.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("He’s just trying to scare me")])]), _vm._v(", she told herself but made a point of walking slowly back to her rental car and hurriedly getting inside—much to his amusement.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("She revved the engine and pulled into the yard of her property, glad when she would be seeing the last of him. As she did, something moved behind a missing shutter at an upstairs window.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“Just leave the gate,” Dulcie said, cutting the engine and getting out of the car. “I might as well have a look around while I’m here.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("He leaned against the gatepost studying her. “Excuse me for saying so, but I don’t think that’s a good idea. I wasn’t joking about the rattlers, especially around an old place like this. Not to mention the fact that you’re trespassing and people around here don’t take kindly to that. You could get yourself shot.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("This last part she really doubted. “I’ll take my chances.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("He shrugged. “I hadn’t taken you for one of them.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“I beg your pardon?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“The morbidly curious.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("Dulcie felt something in her tense. “I’m afraid I don’t know what you’re talking about.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("“A woman was murdered in that house.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_c('span', [_vm._v("She shook her head, not trusting her voice.")])])]), _c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Change your mind about hanging out here?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.” The word came out weakly.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He tried to hide a grin. “Then I should probably warn you that if you get into trouble that cell phone you’ve been clutching won’t be of any use. There’s no coverage out here.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She lifted an eyebrow. She’d never had trouble getting coverage with her cell phone carrier. The man didn’t know what he was talking about. She snapped open her phone. Damn, he was right.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("When she looked up he was walking back toward his combine, shaking his head with each long stride. She could hear him muttering under his breath. “Got better things to do than stand around in this heat arguing with some fool city girl who doesn’t have the sense God gave her.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“So much for Western hospitality,” she muttered under her own breath, then turned toward the house and felt herself shiver despite the heat.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("OLENE")])]), _vm._v(" S"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("TEVENS")])]), _vm._v(" G"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("LANCED")])]), _vm._v(" at the clock on the schoolhouse wall. The hot air coming through the open windows and the sound of the birds and crickets chirping in the grass had all five students looking wistfully toward the cloudless blue sky and the summerlike day outside.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hand in your writing assignments and you may go home a few minutes early,” she said, giving up the fight to keep their attention. “Don’t forget you have another part of your story to write tonight. Tomorrow we will talk about writing the middle of your story.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The air was close inside the schoolhouse, the breeze coming through the open window as hot as dragon’s breath against the back of her neck.")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Jolene lifted her hair as she waited for her sixth-grader, Codi Fox, to collect all the assignments. She tried not to let any of her students see how anxious she was, not that they were paying attention. As Codi put the stack of short stories on the corner of her desk, Jolene made a point of not looking at them.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Instead she watched as her students pulled on their backpacks, answered questions and wished everyone a nice evening. None of them seemed in the least bit interested in the short-story assignments they’d just turned in.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("If one of the students was bringing her the extra story, wouldn’t he or she have been anxious to see Jolene’s reaction? Apparently not.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("After they’d all left, she straightened chairs, turned out lights, picked up around the schoolroom. The small, snub-nosed school bus came and went, taking three of her students with it. She waved to the elderly woman driver, then stood in the shade of the doorway as the parents of her last two students pulled up.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("As soon as the dust settled, Jolene went back inside the classroom to her desk. Her hands were actually trembling as she picked up the short-story assignments, afraid the next installment of the murder story would be among the pile—and afraid it wouldn’t.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She quickly counted the individual stories. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Six")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("With a sigh of relief and an air of apprehension, she sorted through until she found it.")])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_c('i', [_vm._v("T HAD BEEN ONE THOSE")])])]), _vm._v(" hot, dry springs when all the churchgoers in Whitehorse County were praying for rain. The small farming community depended on spring rains and when they didn’t come, you could feel the anxiety growing like a low-frequency electrical pulse ")])])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("that raced through the county and left everyone on edge.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Everyone, that is, but her. She wasn’t worried that day about the weather as she hung her wet sheets on the line behind the old farmhouse and waited")])]), _vm._v("—"), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("not for rain but for the sound of his truck coming up the dead-end road")])]), _vm._v(".")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("OLENE SWALLOWED AND")])]), _vm._v(" looked up, afraid someone would come through the school’s door at any minute and catch her. Reading this felt like a guilty pleasure. Gathering up her work, she stuffed everything into her backpack and biked home.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_vm._v("Once there, she poured herself a glass of lemonade and, unable to postpone it any longer, picked up the story again.")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("T"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_c('i', [_vm._v("HE SWELTERING HEAT ON")])])]), _vm._v(" the wind wrapped her long skirt around her slim legs, and lifted her mane of dark hair off her damp neck as she stared past the clothesline to the dirt road, anticipating her lover’s arrival.")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("She’d sent the little girl off to play with her new friend from across the creek. A long, lazy afternoon stretched endlessly before her and she ached at the thought, her need to be fulfilled by a man as essential as her next breath.")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Over the sound of the weather vane on the barn groaning in the wind and the snap of the sheets as she secured them to the line, she finally heard a vehicle.")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Her head came up and softened with relief, a clothespin between her perfect white teeth, her lightly freckled arms clutching the line as if for support as she watched him turn into the yard.")])])])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Dust roiled up into the blindingly bright day, the ")])])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v("scorching wind lifting and carrying it across the road to the empty prairie.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("She took the clothespin from her mouth, licking her lips as she secured the sheet, then leaving the rest of her wet clothes in the basket, she wiped her hands on her skirt and hurried to meet the man who would be the death of her.")])])])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("J"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("OLENE TOOK A BREATH")])]), _vm._v(" and then reread the pages. She had no more clue as to who could have written this than she had the first time. Nor was she sure why the submission upset her the way it did. It was just fiction, right?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Why give it to her to read though? All she could think was that one of her student’s parents always wanted to write and was looking for some encouragement.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“All my daughter talks about is the short story you’re having the students write,” Amy’s mother had told her. “The other students and their families are talking about it as well. You’ve excited the whole community since I’m told the stories will eventually be bound in a booklet that will be for sale at next year’s fall festival.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Was that how the author of the murder story had found out about the assignment? Which meant it could be anyone, not necessarily one of her student’s parents. But one of the students had to be bringing it in to class.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("Jolene got up and went to the window, hoping for a breath of fresh air. Heat rose in waves over the pale yellow wild grass that ran to the Little Rockies.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("What did the writer expect her to do with this? Just read it? Critique it? Believe it?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("She shuddered as she realized that from the first sentence she’d read of the story, she "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" believed it. But ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("then that was what good fiction was all about, making the reader suspend disbelief.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Even though she knew how the story ended since the writer had begun with the murder, she had the feeling that the writer was far from finished. At least she hoped that was the case. She couldn’t bear the thought that whoever was sending her this might just quit in the middle and leave her hanging.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("She looked forward to seeing the next part of the story Wednesday morning and didn’t want to think that she might never know who or why someone had given it to her to read. As disturbing as the story was, she felt flattered that the writer had chosen her to read it.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("As she stood looking out the window, she had a thought. Had such a murder occurred in this community? The old-timers around here told stories back to the first settlers. If there "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" been a brutal murder around here, she was sure someone would be able to recall it.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Especially one involving a young widow with a daughter living in an old farmhouse one very hot, rainless spring.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Jolene glanced back up the road to the Whitehorse Community Center. Several pickups and an SUV were parked out front for the meeting of the Whitehorse Sewing Circle. If anyone knew about a murder, it would be one of those women.")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("D"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("ULCIE WAITED UNTIL THE")])]), _vm._v(" dust settled from the combine and the cowboy before she turned back to the house. Her gaze was drawn to the second-floor window again and the pale yellow curtain.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("She was sure the color had faded over the years and she couldn’t make out the design on the fabric from here, ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("but something about that yellow curtain felt oddly familiar.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Careful to make sure no rattlesnakes had snuck up while she’d been waiting, she took a few tentative steps toward the house. Had she seen this house with its yellow curtains in a photograph? Surely her parents had one somewhere.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Boards had been nailed across the front door and the lower windows. There would be no getting into the house without some tools. But did she really want to go inside?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("She noticed a sliver of window visible from beneath the boards and moved cautiously through the tall weeds to cup her hands and peer inside.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("She blinked in surprise. The inside of the house was covered in dust, but it looked as if whoever had lived here had just walked out one day and not returned.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("The furniture appeared to be right where it had been, including a book on a side table and a drinking glass, now filled with cobwebs and dust, where someone had sat and read. There were tracks where small critters had obviously made themselves at home, but other than that, the place looked as if it hadn’t been disturbed in years.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Since the murder?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Dulcie felt a chill and told herself the cowboy might have just made that up to scare her, the same way he had warned her about rattlesnakes.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("According to the documents, Dulcie had been left the property twenty-four years before. She would have been four.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Who left property to a four-year-old?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Laura Beaumont apparently.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Dulcie drew back, brushed dust from her sleeve and ")])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_vm._v("started to turn to the rental car to leave when she heard a strange creaking groan that made her freeze.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("What sent her pulse soaring was the realization that she’d heard this exact sound before. She found her feet and stepped around the side of the house to look in the direction the noise was coming from.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("On top of the barn, a rusted weather vane in the shape of a horse moved in the breeze, groaning and creaking restlessly.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Dulcie stood staring at it, her eyes suddenly welling with tears. She "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("had")])]), _vm._v(" been here before. The thought filled her with a horrible sense of dread.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("She wiped at the tears, convinced she was losing her mind. Why else did a pair of yellow curtains and a rusted weather vane make her feel such dread—and worse—such fear?")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d89bd4c2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/smokinsixshooter_ch02.vue
// module id = 78
// module chunks = 0